import axios from 'axios'
import { AnnouncementDto, AnnouncementFilterDto, AnnouncementRequestDto, UpdateAnswerRequestDto } from '../models/dto/Announcement'
import { ApiResponse } from '../models/Base'
import { TableDto } from '../models/dto/SelfAssessment'

const API_URL = process.env.REACT_APP_API_URL
const ACTION_API_URL = `${API_URL}/announcements`

export function GetById(id: number) {
    return axios.get<ApiResponse<AnnouncementDto>>(`${ACTION_API_URL}/${id}`)
}

export function GetByIdAndRead(id: number) {
    return axios.get<ApiResponse<AnnouncementDto>>(`${ACTION_API_URL}/${id}/reads`)
}


export function Search(payload: AnnouncementFilterDto) {
    return axios.post<ApiResponse<AnnouncementDto[]>>(`${ACTION_API_URL}/search`, payload)
}

export function Create(payload: AnnouncementRequestDto) {
    return axios.post(`${ACTION_API_URL}`, payload)
}

export function Update(id: number, payload: AnnouncementRequestDto) {
    return axios.put(`${ACTION_API_URL}/${id}`, payload)
}


export function GetBoard(year: number) {
    return axios.get<ApiResponse<TableDto>>(`${ACTION_API_URL}/boards/${year}`)
}


export function UpdateAnswers(id: number, answer?: UpdateAnswerRequestDto) {
    return axios.put(`${ACTION_API_URL}/${id}/answers`,
        answer,
        { headers: { "Content-Type": "application/json" } }
    )
}
